module.exports = __webpack_public_path__ + "static/media/filter.aefab428.png";